module.exports = __webpack_public_path__ + "media/audio3.efadd66e.wav";